export default __webpack_public_path__ + "img/google-news.d58f738.svg";